import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeChangeOrigin from "./chargeChangeOrigin";
import ChargeChangeResponse from "./chargeChangeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeChangesDuringValidityItemResponse {
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  @Type(() => ChargeChangeResponse)
  changes!: ChargeChangeResponse[];

  @observable
  changeOrigin!: ChargeChangeOrigin;
}
